import { Middleware } from '../middleware'

export default {
  getSiemCorrelationRules(filter) {
    return new Middleware()
      .method('GET')
      .params({
        findBy: filter.findBy,
        page: filter.page - 1,
        size: filter.size,
      })
      .append(`/odin/correlation_rule_definition`)
      .build()
  },
  getSiemCorrelationRulePlaybooks(id) {
    return new Middleware()
      .method('GET')
      .append(`/odin/correlation_rule_definition/${id}/playbooks`)
      .build()
  },
  updateSiemCorrelationRulePlaybooks(data, id) {
    return new Middleware()
      .method('PUT')
      .append(`/odin/correlation_rule_definition/${id}/playbooks`)
      .setData(data)
      .build()
  },
  getSiemCorrelationRuleMitreSkills(id) {
    return new Middleware()
      .method('GET')
      .append(`/odin/correlation_rule_definition/${id}/skills`)
      .build()
  },
  updateSiemCorrelationRuleMitreSkills(data, id) {
    return new Middleware()
      .method('PUT')
      .append(`/odin/correlation_rule_definition/${id}/skills`)
      .setData(data)
      .build()
  },
  updateSiemCorrelationRuleDocumentationRule(id, idRuleDocumentation) {
    return new Middleware()
      .method('PUT')
      .append(
        `/odin/correlation_rule_definition/${id}/documentation/${idRuleDocumentation}`
      )
      .build()
  },
  createSiemCorrelationRules(data) {
    return new Middleware()
      .method('POST')
      .append(`/odin/correlation_rule_definition/`)
      .setData(data)
      .build()
  },
  updateSiemCorrelationRules(data, id) {
    return new Middleware()
      .method('PUT')
      .append(`/odin/correlation_rule_definition/${id}`)
      .setData(data)
      .build()
  },

  getSiemCorrelationRulesById(id) {
    return new Middleware()
      .method('GET')
      .append(`/odin/correlation_rule_definition/${id}`)
      .build()
  },

  getSeverities() {
    return new Middleware()
      .method('GET')
      .append(`/odin/siem_alert_severity/`)
      .build()
  },

  getGrouping(filter) {
    return new Middleware()
      .method('GET')
      .append(`/odin/correlation_rule_definition/grouping_rules`)
      .params({
        search: filter,
      })
      .build()
  },
  getAlertBasics(filter) {
    return new Middleware()
      .method('GET')
      .append(`/odin/siem_alert_basics/`)
      .params({
        search: filter,
        size: 2000
      })
      .build()
  },

  addCorrelation(id, data) {
    return new Middleware()
      .method('POST')
      .append(`/odin/correlation_rule_definition/${id}/grouping_rule`)
      .setData(data)
      .build()
  },

  getCorrelation(id) {
    return new Middleware()
      .method('GET')
      .append(`/odin/siem_alert_basics/correlation_rule_definition/${id}`)
      .build()
  },

  deleteSiemCorrelationRule(id) {
    return new Middleware()
      .method('DELETE')
      .append(`/odin/correlation_rule_definition/${id}`)
      .build()
  },

  removeGroupingRule(id, data) {
    return new Middleware()
      .method('DELETE')
      .append(`/odin/correlation_rule_definition/${id}/grouping_rule`)
      .setData(data)
      .build()
  },

  removeSkillCorrelationRule(ruleId, skillOrSubSkillId, type) {
    return new Middleware()
      .method('DELETE')
      .append(`/odin/correlation_rule_definition/${ruleId}/skill/${skillOrSubSkillId}`)
      .params({ type })
      .build()
  },
  removePlaybookCorrelationRule (idRule, idPlaybook) {
    return new Middleware()
      .method('DELETE')
      .append(`/odin/correlation_rule_definition/${idRule}/playbook/${idPlaybook}`)
      .build()
  }
}
